import { Pipe, PipeTransform } from '@angular/core';
import { Cdn } from '@core/services/cdn';

/**
 * Pipe que permite convertir una url relativa del Backend en una url de cdn y agregar
 * con un ancho deseado en caso de ser necesario
 */
@Pipe({
  name: 'cdnUrl',
  standalone: true,
})
export class CdnUrlPipe implements PipeTransform {
  /** @ignore */
  constructor(private cdn: Cdn) {}

  /**
   * Función que transforma la url relativa del Backend en una url de cdn y agrega un
   * ancho deseado en caso de ser necesario
   * @param url Cadena con la url relativa del Backed
   * @param width Valor del ancho deseado
   * @returns Devuelve la url de la cdn
   */
  transform(
    url: string | undefined | null,
    width?: number | undefined,
    replaceUrl = false,
  ): string {
    if (!url) return '';

    // console.log({ newUrl: this.cdn.replaceUrlBucketWithWidth(url, Number(width)) });

    if (replaceUrl) {
      return this.validWidth(width)
        ? this.cdn.replaceUrlBucketWithWidth(url, Number(width))
        : this.cdn.replaceUrlBucket(url);
    }

    return this.validWidth(width)
      ? this.cdn.changeWidthCDN(url, Number(width))
      : this.cdn.addUrlCDN(url);
  }

  /**
   * Función que verifica si el ancho es un valor permitido
   * @param width Valor del ancho deseado
   * @returns Devuelve true si el ancho es válido
   */
  validWidth(width: number | undefined): boolean {
    return !(width === 0 || width === undefined);
  }
}
